import { Card, CardContent, Grid, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { getFirestore, doc, getDoc } from "@firebase/firestore";
import { useState } from "react";
import { getStudentsPartial } from "framework/students/students_partial";
import { useMaterialUIController } from "context";
import { getLastMarkedAttendance } from "framework/students/attendance";

const InputField = styled(MDInput)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #bababa",
    },
  },
});

const firestore = getFirestore();

const AttendanceCard = ({ setStudentData, setSnackbar, studentCardRef, setErr }) => {
  const [admissionNo, setAdmissionNo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uicontrol] = useMaterialUIController();
  async function getStudentWithAdmissionNo(e) {
    e.preventDefault();
    if (!admissionNo) return;
    try {
      setIsLoading(true);

      //fetching student details
      const studentPromise = getStudentsPartial(admissionNo);
      //fetching last marked attendance of the student
      const lastAttendancePromise = getLastMarkedAttendance(admissionNo);

      const resolvedPromises = await Promise.allSettled([studentPromise, lastAttendancePromise]);
      resolvedPromises.forEach((promise) => {
        if (promise.status === "rejected")
          throw new Error("Failed to get student details, try again.");
      });
      const student = resolvedPromises[0].value;
      const lastAttendance = resolvedPromises[1].value;

      //checking if attendance for today is already marked
      student.isMarked = false;
      if (lastAttendance) {
        const date = lastAttendance.time.toDate();
        const today = new Date();
        if (
          today.getMonth() === date.getMonth() &&
          today.getFullYear() === date.getFullYear() &&
          today.getDate() === date.getDate()
        ) {
          student.isMarked = true;
          setErr("ATTENDANCE FOR TODAY HAS ALREADY BEEN MARKED.");
        }
      }
      student.lastAttendance = lastAttendance;
      setAdmissionNo(null);
      setStudentData(student);

      //setting err message if student is outside
      if (!student.isIn) setErr("CANNOT MARK ATTENDANCE STUDENT IS OUTSIDE.");

      if (!student.isIn) {
        setSnackbar({
          desc: "Attendance cannot be marked for this student as he/she is not in the college.",
          type: "warning",
          icon: "warning",
        });
      }
      setTimeout(() => {
        studentCardRef.current?.scrollIntoView();
      }, 0);
    } catch (err) {
      console.error(err);
      setStudentData(null);
      setSnackbar({
        desc: "Student with the given admission number not found.",
        type: "error",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <>
      <Grid container my={5}>
        <Grid lg={3} md={3} item />
        <Grid lg={6} md={6} xs={12} item>
          <Card sx={{ textAlign: "center" }} raised>
            <MDBox p={2}>
              <CardContent>
                <Grid item xs={12} md={12} lg={12}>
                  <MDTypography variant="h2">Attendance</MDTypography>
                </Grid>
                <form onSubmit={getStudentWithAdmissionNo}>
                  <Grid py={3} container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                      <InputField
                        required
                        fullWidth
                        variant="outlined"
                        label="Admission No"
                        value={admissionNo ?? ""}
                        onChange={(e) => {
                          setAdmissionNo(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <MDButton
                        type="submit"
                        fullWidth
                        variant="gradient"
                        color={uicontrol.sidenavColor}
                        sx={{ height: "40px" }}
                      >
                        {isLoading ? <CircularProgress color="light" /> : "Submit"}
                      </MDButton>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default AttendanceCard;
